import { TFunction } from '@lyearn/i18n';
import { Globe2Outline, Lock2 } from '@lyearn/icons';
import {
  VisibilitySettingsAccessTypeEnum,
  VisibilitySettingsRestrictionTypeEnum,
} from '@/types/schema';

import { VisibilitySettingsAccessTypeTabsType, VisibilitySettingsFormFieldProps } from './types';

const NOT_CONTEXTUAL_GROUP = [
  VisibilitySettingsRestrictionTypeEnum.Groups,
  VisibilitySettingsRestrictionTypeEnum.Users,
];
export const ALL_CONTEXTUAL_GROUPS = Object.values(VisibilitySettingsRestrictionTypeEnum).filter(
  (value) => !NOT_CONTEXTUAL_GROUP.includes(value),
);

export const SIDEBAR_MODE_DEFAULT_OVERRIDES: VisibilitySettingsFormFieldProps['overrides'] = {
  restrictedContent: { overrides: { addButton: { className: 'mt-16' } }, addButtonLength: 'short' },
  selectedList: { mode: 'compact', className: 'mt-16' },
};

export const DEFAULT_OVERRIDES: VisibilitySettingsFormFieldProps['overrides'] = {
  restrictedContent: { overrides: { addButton: { className: 'mt-16' } } },
  selectedList: { className: 'mt-16' },
};

export const getVisibilitySettingsTabs: (t: TFunction) => VisibilitySettingsAccessTypeTabsType[] = (
  t,
) => [
  {
    id: VisibilitySettingsAccessTypeEnum.Open,
    label: t('VisibilitySetting:Everyone'),
    Icon: Globe2Outline,
  },
  {
    id: VisibilitySettingsAccessTypeEnum.Restricted,
    label: t('VisibilitySetting:Specific'),
    Icon: Lock2,
  },
];
